module.exports = __webpack_public_path__ + "img/6.57ad7e70.jpg";